import { DataProvider } from "react-admin";
import { FieldValues } from "react-hook-form";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { AFRR_TESTS, FCR_D_TESTS, FCR_N_TESTS } from "./constants";
import { FormTestConfig, TestConfig, TestKey, TestType } from "./types";

export const getCurrentTestType = (type: TestType): { key: TestKey; label: string }[] => {
  if (type === "fcr_n") return FCR_N_TESTS;
  if (type === "fcr_d") return FCR_D_TESTS;
  if (type === "afrr") return AFRR_TESTS;
  return [];
};

export const buildDagRunPayload = async (values: FieldValues, dataProvider: DataProvider) => {
  const { data: selectedSite } = await dataProvider.getOne(SiteResourcesEnum.Sites, { id: values.site_id });

  const currentTests = getCurrentTestType(values.type as TestType) || [];

  const formattedTestConfigs = values.tests_config.reduce((acc: TestConfig[], test: FormTestConfig, index: number) => {
    const { selected, ...rest } = test;
    if (selected) {
      acc.push({
        ...rest,
        test_name: currentTests[index]?.key || rest.test_name,
      });
    }
    return acc;
  }, []);

  return {
    ...values,
    site_name: selectedSite.name,
    tests_config: formattedTestConfigs,
  };
};
